import axios from 'axios';
import { API_BASE_URL } from '../api-base-url';

export default axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true
});
